import EnumSet from 'Services/enumSet'

interface ICategoryOrder extends EnumSet {
  priority: number
  alphabetic: number
  rating: number
  proximity: number
 }

const categoryOrder = new EnumSet({
  priority: { value: 0, description: 'Mais relevantes' },
  alphabetic: { value: 1, description: 'Ordem alfabética' },
  rating: { value: 2, description: 'Avaliação' },
  proximity: { value: 3, description: 'Proximidade' },
}) as ICategoryOrder

export default categoryOrder